export default {
      id: "i-rocket-icon-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "img/sprite.svg#i-rocket-icon",
      toString: function () {
        return this.url;
      }
    }